// extracted by mini-css-extract-plugin
module.exports = {"items":"submenu-list_items__cvs0H","item":"submenu-list_item__cNwoZ","root":"submenu-list_root__wMskS"};